// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format4 } from '../../constants';

/** Belgium */
const BE: PhoneNumberData = [32, 'BE', 9, format4];

export default BE;
